import { Component, Input, OnInit } from "@angular/core"
import { PremiumSection } from "../../../models/collection/premiumSection.model"
import { PremiumSectionTopic } from "../../../models/collection/premiumSectionTopic.model"
import { WindowSizeService } from "../../../services/window-size.service"
import Utils from "../../../utils/utils"
import { PremiumColors } from "../../../models/collection/premiumColors.model"
import { ActivatedRoute, Route, Router } from "@angular/router"
import { take } from "rxjs/operators"
import { asyncScheduler } from "rxjs"

@Component({
    selector: "app-jump-to-section",
    templateUrl: "./jump-to-section.component.html",
    styleUrls: ["./jump-to-section.component.scss"],
    standalone: false,
})
export class JumpToSectionComponent implements OnInit {
    @Input() public sectionTitle = ""
    @Input() public buttonsList: PremiumSection[] | PremiumSectionTopic[]
    @Input() public isCollectionHomePage: boolean
    @Input() public colors: PremiumColors

    constructor(
        public windowSize: WindowSizeService,
        private router: Router,
        private route: ActivatedRoute
    ) {}

    ngOnInit() {
        this.route.fragment.pipe(take(1)).subscribe((fragment: string) => {
            if (fragment)
                asyncScheduler.schedule(() => {
                    this.jumpTo(fragment)
                }, 1200)
        })
    }

    public jumpTo(text: string): void {
        const selector = ".by-" + Utils.buildCssSelector(text)
        const area = document.querySelector(selector)

        if (area) {
            area.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest",
            })
        }
        this.router.onSameUrlNavigation = "ignore"
        this.router.navigate([], {
            fragment: `${Utils.buildCssSelector(text)}`,
            relativeTo: this.route,
        })
    }
}
